import React, { useEffect, useState, useContext } from "react"
import styled from "styled-components"
import {
  TopRippedHeader,
  H1,
  ReverseButtonLink,
  P,
  ButtonLink,
} from "../general/GeneralStyles"
import Dashboard from "../userAccount/Dashboard"
import AppContext from "../../context/AppContext"

const Hero = styled(TopRippedHeader)`
  min-height: 540px;
  overflow: visible;
  margin-bottom: -5px;
  z-index: 0;

  &::before {
    background-position: 0px 1%;
    overflow: visible;
  }

  @media (max-width: ${props => props.theme.extraLargeBreakpoint}) {
    min-height: 300px;
    margin-bottom: -45px;
  }

  @media (max-width: ${props => props.theme.smallBreakpoint}) {
    > div {
      display: flex;
      flex-direction: column;
      align-items: center;

      > a {
        margin: 0 !important;
        margin-bottom: 10px;
      }
    }
  }
`

/* /products Hero */
const ProductsHero = props => {
  const [loggedIn, setLoggedIn] = useState(false)
  const appContext = useContext(AppContext)

  useEffect(() => {
    if (localStorage.getItem("user") != "{}") {
      setLoggedIn(true)
    }
  })

  return (
    <>
      {loggedIn ? (
        <Dashboard />
      ) : (
        <Hero>
          <H1>Redeem Points for Free Products</H1>
          <P>
            Sign up or log in below to start earning and redeeming Prang Power
            points. Once you’ve banked at least 20 points, you’ll be able to
            start redeeming those points for free school and art supplies.
          </P>
          <div>
            <ButtonLink to="/sign-up">Sign Up</ButtonLink>
            <ReverseButtonLink to="/login">Login</ReverseButtonLink>
          </div>
        </Hero>
      )}
    </>
  )
}

export default ProductsHero
